import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

interface ResultState {
  resultImportOption: any;
}

const initialState: ResultState = {
  resultImportOption: {
    "numOfImports": "0",
    "successImportProducts": "0",
    "successUpdateProducts": "0",
    "failedImportProducts": [],
    "duplicateImportProducts": [],
  }
}

export const resultImportOptionSlice = createSlice({
  name: 'resultImportOption',
  initialState,
  reducers: {
    clear: () => initialState,
    setResult: (state, action) => {
      if (action.payload != 1) {
        state.resultImportOption = action.payload;
      } else {
        clear();
      }
    },
  }
})

export const {
  setResult,
  clear
} = resultImportOptionSlice.actions

export default resultImportOptionSlice.reducer
